import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of, tap } from 'rxjs'
import { CacheService } from 'src/app/shared/services/cache.service'

@Injectable({
  providedIn: 'root',
})
export class CacheInterceptorService implements HttpInterceptor {
  private endpointsToCache: string[] = [
    // PERFIL: ALUNO_REGULAR | ALUNO_ESPECIAL
    // Home
    '/registro-academico',
    // Meus Dados > Atualização Cadastral
    '/endereco-aluno',
    '/contato-pessoa',
    '/dados-pessoais',
    '/dados-academicos',
    '/dados-orientacao',
    // Meus Dados > Horário de Aulas
    '/shared/horario-aulas',
    // Meus Dados > Situação acadêmica
    '/situacao-academica',
    // Meus Dados > Aproveitamento de Créditos
    '/aproveitamento-creditos',
    // Meus Dados > Atividades Complementares
    '/atividade-complementar',
    // Meus Dados > Proficiência em Línguas
    '/proficiencia',
    // Meus Dados > Ocorrências
    '/aluno-afastamento',
    // Meus Dados > Bolsas
    '/bolsa-auxilio',
    // Meus Dados > Prazos
    '/prazos/',
    // Meus Dados > Prazos cumpridos
    '/prazos-cumpridos',
    // Meus Dados > Mobilidades
    '/mobilidade',
    // Consultas > Dados do Curso
    '/dados-curso',
    '/dados-area-concentracao',
    '/dados-regulamento',
    '/dados-reconhecimento',
    // Consultas > Disciplinas do Programa
    '/disciplinas-programa',
    // Consultas > Calendário Escolar
    '/calendario-escolar',
    // Consultas > Minhas Disciplinas
    '/disciplina-cursada',
    // Mensagens > Recebidas
    '/mensagem',
    // Processo Seletivo > Regular | Especial
    '/publico/unidade-universitaria',
  ]

  constructor(private cacheService: CacheService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ignora o que não for GET
    if (request.method !== 'GET') {
      return next.handle(request)
    }

    // ignora acessos do perfil STPG e PROPG
    if (request.url.includes('/stpg/') || request.url.includes('/propg/') || request.url.includes('/shared/')) {
      return next.handle(request)
    }

    // ignora tudo que não foi previamente definido para manter cache
    if (!this.endpointsToCache.some(value => request.url.includes(value))) {
      return next.handle(request)
    }
    // verifica se existe no cache
    const cachedKey = request.urlWithParams
    const cachedResponse = this.cacheService.getFromCache(cachedKey)
    if (cachedResponse) {
      // retorna cache
      return of(cachedResponse)
    }
    // retorna requisição normalmente
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // armazena em cache
          this.cacheService.addToCache(cachedKey, event)
        }
      })
    )
  }
}
